import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { MeuContexto } from "../App"
import { data_user } from '../api/datauser'
import { validarME } from '../api/apiMe'
import { global } from '../api/global'
import personagem from '../img/person.png'

import Button from '../components/Button.jsx';
import Input, { TextArea } from '../components/Input.jsx';
import CompActive from '../components/CompActive.jsx';
import { CameraIcon } from '@heroicons/react/24/solid';

const PgUsuario = () => {
  let navigate = useNavigate();
  const { logado, setlogado, setuser } = useContext(MeuContexto)

  const [isloading, setIsLoading] = useState(true);
  const [userid, setUserid] = useState(0)
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [comment, setComment] = useState('');
  const [isArtist, setIsArtist] = useState(false);
  const [style, setStyle] = useState('');
  const [cpf, setCpf] = useState('');
  const [title, setTitle] = useState('');
  const [isLivePaid, setIsLivePaid] = useState(false);
  const [price, setPrice] = useState('');
  const [isWifi, setIsWifi] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [profilePhotoFile, setProfilePhotoFile] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    _carregatela()
  }, [])

  useEffect(() => {
    if (!logado) { navigate("/") }
  }, [logado])

  async function _carregatela() {
    const me = await validarME.me()
    if (me) {
      setuser(me);
      setUserid(me._id);
      setUsername(me.username);
      setEmail(me.email);
      setCpf(me.cpf || '');
      setComment(me.comment || '');
      setIsArtist(me.artist);
      setIsLivePaid(me.paga);
      setPrice(me.preco || '');
      setStyle(me.estilo || '');
      setTitle(me.title || '');
      setIsWifi(me.wifi);
      if (me.fotoid) {
        setProfilePhoto(`${global.brl.REACT_APP_FOTO}${me.fotoid}.jpg`);
      }
    } else {
      setuser([]);
      setlogado(false);
    }
    setIsLoading(false);
  }

  async function _salvar() {
    setIsLoading(true);
    const data = {
      id: userid,
      username, email, cpf, comment,
      artist: isArtist, paga: isLivePaid, preco: price,
      estilo: style, title, wifi: isWifi,
    };
    
    // Here you would also handle the photo upload if profilePhotoFile is set
    // For example, using a FormData object if you have an endpoint for it.

    const resposta = await data_user.atualizar(data);
    if (resposta) {
      toast.success('Seu perfil foi atualizado com sucesso!');
    } else {
      toast.error('Não foi possível atualizar seu perfil.');
    }
    setIsLoading(false);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add validation logic here if needed
    _salvar();
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfilePhotoFile(file);
      setProfilePhoto(URL.createObjectURL(file));
    }
  };
  
  const handleLogout = () => {
    setlogado(false);
    // You might want to also clear localStorage/cookies here
    navigate('/');
  }

  if (isloading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <CompActive size="lg" text="Carregando Perfil..." />
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-background text-text selection:bg-primary/30">
      <ToastContainer theme="dark" position="bottom-right" />
      <div className="max-w-screen-lg mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-display font-bold text-text">
            Configurações da Conta
          </h1>
          <p className="mt-2 text-lg text-text-subtle">Gerencie seu perfil e suas configurações.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-12">
            {/* Profile Section */}
            <section className="bg-surface border border-border rounded-2xl p-8">
                <h2 className="text-2xl font-display font-bold text-primary mb-6">Meu Perfil</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Profile Photo */}
                    <div className="md:col-span-1 h-48 rounded-xl overflow-hidden">
                    <div className="relative">
                            <img
                                src={profilePhoto || personagem}
                                alt="Profile"
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                />
                            <label 
                                htmlFor="profilePhoto" 
                                className="absolute bottom-6 right-6 bg-primary hover:bg-primary-dark text-white p-3 rounded-full cursor-pointer transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-surface"
                            >
                                <CameraIcon className="w-6 h-6" />
                                <input
                                    type="file"
                                    id="profilePhoto"
                                    accept="image/*"
                                    onChange={handlePhotoChange}
                                    className="hidden"
                                />
                            </label>
                        </div>
                    </div>
                    {/* User Info */}
                    <div className="md:col-span-2 space-y-6">
                        <Input
                            label="Nome de usuário"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <Input
                            label="E-mail"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                         <TextArea
                            label="Bio / Comentário"
                            rows="3"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Conte-nos um pouco sobre você..."
                        />
                    </div>
                  
                </div>
            </section>
            
            {/* Artist Section */}
            {isArtist && (
                 <section className="bg-surface border border-border rounded-2xl p-8 animate-fade-in">
                    <h2 className="text-2xl font-display font-bold text-primary mb-6">Detalhes do Artista</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <Input
                            label="Estilo Artístico (ex: Música, Teatro)"
                            type="text"
                            value={style}
                            onChange={(e) => setStyle(e.target.value)}
                        />
                         <Input
                            label="CPF (para pagamentos)"
                            type="text"
                            value={cpf}
                            onChange={(e) => setCpf(e.target.value)}
                        />
                         <Input
                            label="Título da Próxima Live"
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                        <Input
                            label="Preço do Ingresso (ex: 25,50)"
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            disabled={!isLivePaid}
                        />
                        <div className="flex items-center space-x-3 pt-2 md:col-span-2">
                             <input
                                type="checkbox"
                                id="isLivePaid"
                                checked={isLivePaid}
                                onChange={(e) => setIsLivePaid(e.target.checked)}
                                className="w-5 h-5 bg-surface border-border text-primary rounded focus:ring-primary focus:ring-2 focus:ring-offset-surface"
                            />
                            <label htmlFor="isLivePaid" className="text-text-subtle font-medium select-none">
                                Minhas lives são pagas
                            </label>
                        </div>
                    </div>
                </section>
            )}

            {/* Actions */}
            <section className="flex justify-between items-center">
                <Button variant="ghost" onClick={handleLogout}>
                    Sair
                </Button>
                <Button type="submit" variant="primary" size="lg" loading={isloading}>
                    {isloading ? 'Salvando...' : 'Salvar Alterações'}
                </Button>
            </section>
        </form>
      </div>
    </main>
  );
}

export default PgUsuario;
